import { render, staticRenderFns } from "./IncidentCard.vue?vue&type=template&id=a43ce1cc&"
import script from "./IncidentCard.vue?vue&type=script&lang=ts&"
export * from "./IncidentCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports